<template>
  <div class="new-home-consult">
    <div>
      <strong>与生态伙伴共创自主创新未来</strong>
      <p>
        为政企用户提供学习、交流、共创的自主创新生态，智能伴行数字化转型升级！
      </p>
      <!-- <a-button class="btn-red" @click="$router.push('/activity')"
        >进入培训课程</a-button
      > -->
      <div class="new-home-consult-content">
        <div class="consult-activity-box">
          <span
            ><img src="@/assets/img/zxkcicon.png" alt="图片" /> 活动大厅</span
          >
          <div>
            <a-carousel autoplay dot-position="bottom">
              <template v-for="(el, index) in activityList">
                <div
                  :key="el.id"
                  v-if="index < 3"
                  @click="$router.push(`/activity/activityInfo?id=${el.id}`)"
                  class="consult-activity-list"
                >
                  <h3>{{ el.activityName }}</h3>
                  <div class="text-overflow3">{{ el.summary }}</div>
                  <span
                    >报名时间:
                    {{ dayjs(el.enrollStartTime).format("YYYY-MM-DD") }} ~
                    {{ dayjs(el.enrollEndTime).format("YYYY-MM-DD") }}</span
                  >
                  <a-button @click.stop="$router.push(`/activity/activity`)"
                    >查看更多<a-icon type="right"
                  /></a-button>
                </div>
              </template>
            </a-carousel>
          </div>
        </div>
        <div class="consult-course-box">
          <div class="consult-course-title">
            <span
              ><img src="@/assets/img/keceng.png" alt="图片" /> 实训课程</span
            >
            <p @click="$router.push(`/activity`)">更多培训课程 ></p>
          </div>
          <div class="consult-course-list">
            <template v-for="(el, index) in courseList">
              <div
                :key="el.id"
                v-if="index < 4"
                @click="$router.push(`/activity/courseInfo?id=${el.id}`)"
              >
                <p>
                  {{ el.courseName }}
                </p>
                <span>{{ el.summary }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityList, getCourseList } from "@/api/activity";
import dayjs from "dayjs";
export default {
  data() {
    return {
      activityList: [],
      courseList: [],
      dayjs,
    };
  },
  mounted() {
    this.loadgetCourseList();
    this.loadGetActivityList();
  },
  methods: {
    loadgetCourseList() {
      let page = {
        current: 1,
        size: 6,
      };
      getCourseList(page, {}).then((res) => {
        this.courseList = res.records;
      });
    },
    loadGetActivityList() {
      let page = {
        current: 1,
        size: 3,
      };
      getActivityList(page, {}).then((res) => {
        this.activityList = res.records;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-home-consult {
  padding: 64px 0 76px;
  background: #fff;
  > div {
    width: 1280px;
    margin: 0 auto;
    > strong {
      display: block;
      font-size: 32px;
      line-height: 45px;
      color: #262626;
      margin-bottom: 16px;
      text-align: center;
    }
    > p {
      font-size: 16px;
      line-height: 22px;
      color: #666;
      margin-bottom: 64px;
      text-align: center;
    }
    > div {
      margin-top: 110px;
      background: #ffffff;
      border-radius: 4px;
      position: relative;
      display: flex;
      .consult-swiper-list {
        padding: 32px;
        position: relative;
        width: 33.3%;
        &::after {
          content: "";
          position: absolute;
          top: 32px;
          bottom: 32px;
          right: -1px;
          width: 1px;
          background: #e6e6e6;
        }
        &:last-child {
          &::after {
            display: none;
          }
        }
        > div {
          height: 100%;
          > span {
            display: flex;
            align-items: center;
            font-size: 18px;
            line-height: 25px;
            color: #262626;
            margin-bottom: 30px;
            > img {
              width: 28px;
              margin-right: 12px;
            }
          }
          > p {
            font-size: 16px;
            line-height: 22px;
            color: #262626;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 14px;
            cursor: pointer;
            transition: all 0.3s;
            &:last-child {
              margin-bottom: 0;
            }
            &:hover {
              color: #ea0b06;
            }
          }
        }
      }
    }
  }
  .new-home-consult-content {
    display: flex;
    justify-content: space-between;
    .consult-activity-box {
      width: 432px;
      background: url(../../assets/img/2.0/hddtbg.png) no-repeat;
      background-size: 100% 100%;
      padding: 18px 24px;
      > span {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
        margin-bottom: 34px;
        > img {
          margin-right: 12px;
        }
      }
      > div {
        height: calc(100% - 62px);
        ::v-deep .ant-carousel {
          height: 100%;
          > div {
            height: 100%;
          }
        }
        .consult-activity-list {
          cursor: pointer;
          > h3 {
            font-size: 16px;
            color: #262626;
            line-height: 24px;
            margin-bottom: 24px;
          }
          > span {
            display: block;
            font-size: 14px;
            color: #666666;
            line-height: 24px;
            margin-top: 24px;
          }
          > div {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #666666;
            line-height: 24px;
            > p {
              display: flex;
              align-items: center;
              color: #262626;
              > span {
                color: #ea0b06;
              }
            }
          }
          > button {
            margin-top: 48px;
            background: #ea0b06;
            color: #fff !important;
          }
        }
      }
    }
    .consult-course-box {
      width: 824px;
      .consult-course-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fafbfd;
        padding: 0 24px;
        height: 64px;
        > span {
          display: flex;
          align-items: center;
          font-weight: bold;
          font-size: 20px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 28px;
          > img {
            margin-right: 12px;
          }
        }
        > p {
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          cursor: pointer;
        }
      }
      .consult-course-list {
        display: flex;
        flex-wrap: wrap;
        > div {
          height: 194px;
          width: 50%;
          padding: 24px;
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
          cursor: pointer;
          &:first-child {
            border-left: 1px solid #e8e8e8;
          }
          &:nth-child(3n) {
            border-left: 1px solid #e8e8e8;
          }
          > p {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 24px;
          }
          > span {
            display: block;
            font-size: 14px;
            color: #666666;
            line-height: 20px;
            max-height: 80px;
            overflow: hidden;
          }
          > div {
            display: flex;
            > span {
              display: flex;
              align-items: center;
              margin-right: 24px;
              color: #666666;
              > img {
                margin-right: 8px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
